module.exports = __webpack_public_path__ + "img/q8.5a3a2fad.png";